<template>
  <kst-table action paginated view-mode
    :data="items"
    :selected.sync="userData.selected"
  >
    <b-table-column
      v-slot="{ column, row }"
      cell-class="ks-col-image"
      field="DispatchImageSrc"
      :label="RcvItemCatalog.DispatchImageSrc.Label"
    >
      <kst-image read-only thumbnail :src="row[column.field]"/>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row }"
      field="DispatchID"
      :label="RcvItemCatalog.Name.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="RcvItemCatalog"/>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row }"
      cell-class="ks-col-sku"
      field="SKU"
      :label="RcvItemCatalog.SKU.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="RcvItemCatalog"/>
    </b-table-column>

    <b-table-column numeric
      v-slot="{ column, row }"
      cell-class="ks-col-qty"
      field="QtyAvailable"
      :label="RcvItemCatalog.QtyAvailable.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="RcvItemCatalog"/>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row }"
      cell-class="ks-col-packaging"
      field="Packaging"
      :label="RcvItemCatalog.Packaging.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="RcvItemCatalog"/>
    </b-table-column>

    <b-table-column numeric
      v-slot="{ column, row }"
      cell-class="ks-col-price"
      field="BuyPrice"
      :label="RcvItemCatalog.BuyPrice.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="RcvItemCatalog"/>
    </b-table-column>
  </kst-table>
</template>

<script>
import RcvItemCatalog from "../RcvItemCatalog.js";

export default {
  props: {
    items: Array,
    userData: Object
  },
  data: () => ({
    RcvItemCatalog: RcvItemCatalog
  })
}
</script>